import { IPlayer, IUserStore } from '../../user/store';
import { ICourse } from '../courses/store';

export interface IClubCreationForm {
  name: string;
}

export interface IAdminClub {
  about?: string;
  backgroundImage?: string | null;
  course: ICourse;
  description: string;
  email: string;
  id: number;
  membershipPrice: string;
  name: string;
  owner?: IUserStore;
  policy?: string;
  processPayment: boolean;
  profileImage?: string | null;
  status?: string;
}

export interface IClubOfficer {
  club: number;
  id: number;
  isAdmin: boolean;
  isOwner: boolean;
  isStaff: boolean;
  position: string;
  status: string;
  user: IPlayer;
}

export interface INewClubOfficerForm {
  club: number;
  isAdmin: boolean;
  isOwner?: boolean;
  isStaff: boolean;
  position: string;
  status: 'active' | 'inactive';
  user: number;
}

export interface IClubOfficersStore {
  [key: string]: IClubOfficer;
}

export interface IClubTransactionAddon {
  id: number;
  name: string;
  event: number;
  price: string;
}

export interface IClubTransactionItems {
  addons: IClubTransactionAddon[];
  eventPrice: {
    id: number;
    end: string;
    name: string;
    event: number;
    price: string;
    start: string;
    ageTo?: string;
    ageFrom?: string;
  };
  eventName: string;
  clubMembershipPrice: string;
}

export interface IClubTransactionSummary {
  items: IClubTransactionItems;
  coupon: { title: string; codename: string; discountValue: string };
  totalPrice: string;
  subtotalPrice: string;
}

export interface IClubTransaction {
  id: number;
  amount: string;
  amountRefunded: string;
  payeer: IUserStore;
  description: string;
  processorId: string;
  club: string;
  status: string;
  created: string;
  summary: IClubTransactionSummary;
}

export interface IAdminClubsStore {
  all: {
    [key: number]: IAdminClub;
  };
  [key: number]: IAdminClub;
  current?: IAdminClub;
  transactions: { [clubId: string]: { [transactionId: string]: IClubTransaction } };
  management: {
    [clubId: string]: IClubOfficersStore;
  };
}

export const adminClubsStore: IAdminClubsStore = {
  all: {},
  management: {},
  transactions: {}
};
